import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-successful-consultant-creation',
  templateUrl: './successful-consultant-creation.component.html',
  styleUrls: ['./successful-consultant-creation.component.scss'],
  standalone: false
})
export class SuccessfulConsultantCreationComponent implements OnInit {
  breadCrumbs = [
    { label: 'Login', path: 'app/login'},
    { label: 'Successful Consultant Creation'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageName = 'Successful Consultant Creation';

  constructor(private routerChild: Router,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Successful Consultant Creation");
  }

  ngOnInit() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/login');
    }
    setTimeout(counterFn, 10000);
  }

  onGoToLogin(): void {
    this.routerChild.navigateByUrl('app/login');
  }
}
